import axios from "axios";
// import qs from "qs";
import authHeader from "./auth-header";

const END_POINT = `${process.env.VUE_APP_API_ENDPOINT}`;

class PreviewReserveService {
  async findInPreview(previewid) {
    console.log("+++ find");
    console.log(previewid);
    const result = await axios.get(
      END_POINT + `/api/preview_reserve/preview/${previewid}`,
      {
        headers: authHeader(),
      },
    );
    return result;
  }
  async find(query) {
    console.log("+++ find");
    console.log(query);
    const result = await axios.get(END_POINT + `/api/preview_reserve`, {
      params: query,
      headers: authHeader(),
    });
    return result;
  }

  async findByID(id) {
    const result = await axios.get(END_POINT + `/api/preview_reserve/${id}`, {
      headers: authHeader(),
    });
    return result;
  }

  async create(params) {
    console.log("+++ find");
    console.log(params);
    const result = await axios.post(
      END_POINT + `/api/preview_reserve`,
      params,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async createByUser(params) {
    console.log("+++ find");
    console.log(params);
    const result = await axios.post(
      END_POINT + `/api/preview_reserve_user`,
      params,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async update(params) {
    const result = await axios.put(
      END_POINT + `/api/preview_reserve/${params._id}`,
      params,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async remove(id, isAdmin) {
    const result = await axios.delete(
      END_POINT + `/api/preview_reserve/${id}`,
      {
        headers: authHeader(),
        data: { isAdmin },
      },
    );
    return result;
  }
}

export default new PreviewReserveService();
